import React from 'react';

import { useWindowSize } from '../../../lib/hooks';
import StarStroke from '../assets/star-stroke.svg?react';
import StarFill from '../assets/star-fill.svg?react';
import PropTypes from 'prop-types';

import styled from 'styled-components';

const Container = styled.div`
    width: 18px;
    height: 18px;

    &[disabled] > svg {
        fill: var(--gray200);
    }

    &:hover:not([disabled]) {
        cursor: pointer;
    }
`;

const SingleStar = ({ number, selected = 0, onClick, setStarHover, hover, disabled = false }) => {
    const { innerWidth } = useWindowSize();
    const isMobile = innerWidth < 767;

    const getStar = (number, selected, hover) => {
        if (isMobile) {
            return number < selected ? <StarFill /> : <StarStroke />;
        }
        return number < selected || number < hover ? <StarFill /> : <StarStroke />;
    };

    return (
        <Container
            disabled={disabled}
            onClick={disabled ? null : onClick}
            onMouseOver={() => {
                if (disabled) {
                    return;
                }
                setStarHover(number + 1);
            }}
        >
            {getStar(number, selected, hover)}
        </Container>
    );
};
SingleStar.propTypes = {
    /** Indice della Stella in hover. */
    hover: PropTypes.number,
    /** Numero di stelle selezionate. */
    selected: PropTypes.number,
    /** Comunica al padre l'indice di stella in hover. */
    setStarHover: PropTypes.func,
    /** Definisce il comportamento della stella quando è cliccata. */
    onClick: PropTypes.func,
    /** Definisce l'indice della stella selezionata. */
    number: PropTypes.number,
    disabled: PropTypes.bool,
};

export default SingleStar;
